<template>
  <div class="modal-message">
    <div class="card" v-loading="loading" element-loading-spinner="qc-spinner">
      <div class="card-header">
        <h4 class="card-title">Request a new institute</h4>
        <p class="category">Please provide us with details of the institute you'd like us to add to our coverage and we will determine if we can support it.</p>
      </div>
      <div class="card-content">
        <div class="form-group">
          <label>Name</label>
          <input class="form-control" v-model="name" :maxlength="200" />
          <span class="help-block">{{nameCharsLeft}} character(s) left.</span>
        </div>
        <div class="form-group">
          <label>Country</label>
          <input class="form-control" v-model="country" :maxlength="200" />
          <span class="help-block">{{countryCharsLeft}} character(s) left.</span>
        </div>
        <div class="form-group">
          <label>Additional Information</label>
          <input class="form-control" v-model="comment" :maxlength="1000" />
          <span class="help-block">{{commentCharsLeft}} character(s) left.</span>
        </div>
      </div>
      <div class="card-footer row">    
        <div class="col-md-12">
          <button @click="$modal.close()" class="btn">Cancel</button>
          <button @click="submit" class="btn btn-fill pull-right">Submit</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'modal-message',
    data () {
      return {
        loading: false,
        name: this.nameInit,
        country: this.countryInit,
        comment: null
      }
    },
    props: {
      nameInit: String,
      countryInit: String
    },
    computed: {
      nameCharsLeft() {
        return 200 - (this.name != null ? this.name.length : 0)
      },
      countryCharsLeft() {
        return 200 - (this.country != null ? this.country.length : 0)
      },
      commentCharsLeft() {
        return 1000 - (this.comment != null ? this.comment.length : 0)
      }
    },
    methods: {
      submit () {
        this.loading = true
        this.$api.requestInstitute(this.name, this.country, this.comment)
          .then(response => {
            this.loading = false
            this.$snotify.success("Institute request sent", "Success")
            this.$modal.close()
          })
          .catch(error => {
            this.loading = false
          })
      }
    }
  }
</script>

<style>
  .modal-message {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>